import { EarHearingOffIcon } from './EarHearingOffIcon';

/**
 * author: Henrique César Madeira
 * id 78ACE34A-8AC2-4259-AD8D-1118A11C6800
 * name ear-hearing-off
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ear-hearing-off.svg
 * tags
 * - Medical / Hospital 
 */
export const HearingImpairedIcon = EarHearingOffIcon;
export default HearingImpairedIcon